import React, { Component, PureComponent } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment-timezone'
import FormControl from 'react-bootstrap/lib/FormControl'
// import '../../../assets/css/react-datepicker.css'
// import '../../../assets/css/datepicker.css'

const defaultDateFormat = 'DD/MM/YYYY'
const defaultTimeFormat = 'HH:mm'


class ExploriDateTimeField extends Component {
    dateTimeText = ''

    state = {
        dateTimeText: '',
        key: new Date().getTime(),
    }

    constructor(props) {
        super(props)
        const { dateTime, dateTimeFormat } = this.props
        this.dateTimeFormat = dateTimeFormat
        if (dateTime) {
            this.dateTime = moment(dateTime, this.dateTimeFormat)
            this.state = {
                dateTimeText: dateTime,
                key: new Date().getTime(),
            }
        }
    }

    validateDateTimeText = ({ target }) => {
        const { onBlur, forceBlur, allowBlank } = this.props
        console.log('validateDateTimeText')
        const { value } = target
        const dateTime = moment(value, this.dateTimeFormat, true)
        // && value.match(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}$/)
        if (dateTime.isValid()) {
            console.log(`momentTime ${value}`)
            this.dateTime = dateTime
            if (onBlur) {
                onBlur(dateTime)
            }
        } else {
            console.log('just text')
            console.log(this.dateTimeText)
            const key = new Date().getTime()
            if (this.dateTime && (!allowBlank || value !== '')) {
                console.log(this.dateTime.format(this.dateTimeFormat))
                console.log(key)
                this.setState({
                    dateTimeText: this.dateTime.format(this.dateTimeFormat),
                    key,
                })
            } else {
                this.setState({
                    dateTimeText: '',
                    key,
                })
                if (allowBlank) {
                    if (onBlur) {
                        onBlur('')
                    }
                }
            }
            if (forceBlur) {
                forceBlur(dateTime)
            }
        }
    }

    render() {
        console.log(`render ExploriDateTimeField ${this.state.dateTimeText} ${this.state.key}`)
        return (
            <input type="text"
                onBlur={this.validateDateTimeText}
                defaultValue={this.state.dateTimeText}
                key={this.state.key}
                placeholder={this.props.placeholder || 'Select start date'}
                type='text'/>
        )
    }
}

// @observer
class ExploriDatePicker extends PureComponent {
    calendarOpen = false

    dateTimeFormat = 'DD/MM/YYYY HH:mm'

    timeFormat = 'HH:mm'

    timeInterval = 30

    constructor(props) {
        super(props)
        const {
            dateTimeFormat,
            timeFormat,
            dateTimeText,
            timeInterval,
            dateOnly,
        } = props

        if (dateTimeFormat) {
            this.dateTimeFormat = dateTimeFormat
        } else if (dateOnly) {
            this.dateTimeFormat = defaultDateFormat
        } else {
            this.dateTimeFormat = `${defaultDateFormat} ${defaultTimeFormat}`
        }

        if (timeFormat) {
            this.timeFormat = timeFormat
        }

        if (timeInterval) {
            this.timeInterval = timeInterval
        }
        this.state = {
            lastDateTimeProp: dateTimeText,
            dateViewerKey: new Date().getTime(),
            dateTime: dateTimeText,
            dateTimeText: dateTimeText ? dateTimeText.format(this.dateTimeFormat) : '',
            showTime: false,
            dateTimeFormat: this.dateTimeFormat,
            reset: undefined,
        }
    }

    static getDerivedStateFromProps(props, state) {
        let newState = null
        console.log(`dateTimePicker getDerivedStateFromProps ${props.dateTimeText} !== ${state.lastDateTimeProp}`)
        if (props.dateTimeText !== state.lastDateTimeProp) {
            newState = {
                lastDateTimeProp: props.dateTimeText,
                dateViewerKey: new Date().getTime(),
                dateTime: props.dateTimeText,
                dateTimeText:  props.dateTimeText ? props.dateTimeText.format(state.dateTimeFormat) : '',
                reset: state.reset,
            }
        } else if (props.reset !== state.reset) {
            newState = {
                lastDateTimeProp: state.dateTimeText,
                dateViewerKey: new Date().getTime(),
                dateTime: undefined,
                dateTimeText: '',
                reset: props.reset,
            }
        }
        return newState
    }

    toggleCalendar = () => {
        this.calendarOpen = this._calendar.isOpen ? false : true
        this.setState({
            showTime: false,
        })
        this._calendar.setOpen(this.calendarOpen)
    }

    toggleTime = () => {
        this.calendarOpen = this._calendar.isOpen ? false : true
        this.setState({
            showTime: true,
        })
        this._calendar.setOpen(this.calendarOpen)
    }

    validateClosingDate = () => {
        console.log('validateClosingDate')
        this.calendarOpen = false
        this.setState({
            showTime: false,
        })
    }

    changeDateTime = (dateTimeObj) => {
        const { onChange } = this.props
        this.setState({
            dateTime: dateTimeObj,
            dateTimeText: dateTimeObj.format(this.dateTimeFormat),
            dateViewerKey: new Date().getTime(),
        })
        if (onChange) {
            onChange(dateTimeObj)
        }
    }

    validateDateTimeText = (dateTimeObj) => {
        const { onChange, onBlur } = this.props
        this.setState({
            dateTime: dateTimeObj,
        })
        if (onBlur) {
            onBlur(dateTimeObj)
        }
        if (onChange) {
            onChange(dateTimeObj)
        }
    }

    render() {
        const {
            calendarClassName,
            dateOnly,
            minDate,
            maxDate,
            onBlur,
            forceBlur,
            calendarIcon,
        } = this.props
        const calendarCss = `exploriCalendar ${this.showTime ? 'timeOnly' : 'dateOnly'}`
        const className = `calendar ${calendarClassName}`
        console.log(`calendar render ${calendarCss} ${this.showTime} ${this.state.datePickerKey}`)
        return (
            <div className={className}>
                <DatePicker className=""
                    ref={(c) => { this._calendar = c }}
                    onBlur={this.validateClosingDate}
                    onChange={this.changeDateTime}
                    showTimeSelect={this.state.showTime}
                    showTimeSelectOnly={this.state.showTime}
                    popperPlacement="top-end"
                    timeFormat={this.timeFormat}
                    minDate={minDate}
                    maxDate={maxDate}
                    timeIntervals={this.timeInterval}
                    popperClassName='exploriCalendarPopper'
                    calendarClassName={calendarCss}
                    selected={this.state.dateTime}
                    dateFormat={this.dateTimeFormat}
                />
                <ExploriDateTimeField
                    key={this.state.dateViewerKey}
                    dateTime={this.state.dateTimeText}
                    dateTimeFormat={this.dateTimeFormat}
                    onBlur={this.validateDateTimeText}
                    forceBlur={forceBlur}
                    placeholder={this.props.placeholder}
                    allowBlank={this.props.allowBlank}
                />
                <div className="calendarIcon"><i className={calendarIcon || 'far fa-calendar-alt'} onClick={this.toggleCalendar}/></div>
                { !dateOnly
                    && <i className='far fa-clock' onClick={this.toggleTime}/>
                }
            </div>
        )
    }
}

export default ExploriDatePicker
